import React from "react";

export const CustomerDetailContext = React.createContext(null);

export const useCustomerDetailContext = () =>{
    const context = React.useContext(CustomerDetailContext);

    if(!context) throw new Error("Customer Details Context Not Provided");

    return context
};